import { CreditAccountStatusPDFPage } from './creditAccountStatusPDFPage'
import { ItemsPDFWrapper } from '../../../../../features/ui'
import { Data2 } from "../../../../../features/data-types"
import { CodedDataType } from '../../../../../tables'
import { Item } from '../../../../operations'

type Props = {
    id: string
    customerId: string
    rows: Data2[]
    summary: {
        limit: string
        available: string
        debt: string
        creditBalance?: string
        netBalance?: string
        netBalanceLabel: string
    }
    previewMode?: boolean
    dateFrom?: string | Date
    dateTo?: string | Date
}

export const CreditAccountStatusPDF = (props: Props) => {
    const { id, customerId, rows, summary, previewMode, dateFrom, dateTo } = props

    const renderPDFPage = (
        pageIndex: number,
        _dataType: CodedDataType,
        items: Item[],
        pagesAmount: number
    ) => (
        <CreditAccountStatusPDFPage
            pageIndex={pageIndex}
            customerId={customerId}
            rows={items as unknown as Data2[]}
            summary={summary}
            pagesAmount={pagesAmount}
            dateFrom={dateFrom}
            dateTo={dateTo}
        />
    )

    return (
        <ItemsPDFWrapper
            id={id}
            items={rows as unknown as Item[]}
            previewMode={previewMode}
            firstPageMaxItems={16}
            pageMaxItems={22}
            reserveLastPageSpace={false}
            renderPDFPage={renderPDFPage}
        />
    )
}
